import { buildRecommendationAmendUndoState } from "./recommendation-amend-undo"
import { mergeAuthoringRecommendationNote } from "../controller/merge-authoring-recommendation-note"
import { buildRecommendationNoteContent, mergeRecommendationNoteContents } from "./recommendation-note-content"

export async function saveAuthoringRecommendationAmend({
    saveAmend,
    authoringAmends = [],
    projectId,
    scheduleId,
    amendsKey,
    recommendationId,
    sourceType,
    sourceRecordId,
    sourceLabel,
    sourceRoute,
    noteRecommendations = [],
}) {
    if (!saveAmend || !amendsKey) return null

    const existing = authoringAmends.find((amend) => amend?.payload?.amendsKey === amendsKey) ?? null
    const prepared = await resolveRecommendationAmendContent({
        existing,
        noteRecommendations,
        projectId,
        scheduleId,
        amendsKey,
        targetLabel: noteRecommendations[0]?.targetLabel,
        changeLabel: noteRecommendations[0]?.changeLabel,
    })

    const savedAmend = await saveAmend({
        amendsKey,
        content: prepared.content,
        recommendationId,
        sourceType,
        sourceRecordId,
        sourceLabel,
        sourceRoute,
    })

    return buildRecommendationAmendUndoState({
        existingAmend: prepared.existingAmend,
        savedAmend,
    })
}

async function resolveRecommendationAmendContent({
    existing,
    noteRecommendations = [],
    projectId,
    scheduleId,
    amendsKey,
    targetLabel,
    changeLabel,
}) {
    const existingContent =
        existing?.payload?.content || existing?.payload?.internalContent || existing?.payload?.externalContent || ""
    const nextContents = noteRecommendations.map(buildRecommendationNoteContent).filter(Boolean)

    if (!projectId || !scheduleId || !amendsKey) {
        return {
            content: mergeRecommendationNoteContents(existingContent, nextContents),
            existingAmend: existing,
        }
    }

    try {
        const merged = await mergeAuthoringRecommendationNote({
            projectId,
            scheduleId,
            amendsKey,
            nextContent: nextContents[0] || "",
            nextContents,
            changeLabel,
            targetLabel,
        })

        return {
            content:
                `${merged?.content || ""}`.trim() || mergeRecommendationNoteContents(existingContent, nextContents),
            existingAmend: merged?.existingAmend || existing,
        }
    } catch (error) {
        console.warn("Falling back to local recommendation note merge", error)
        return {
            content: mergeRecommendationNoteContents(existingContent, nextContents),
            existingAmend: existing,
        }
    }
}
